type Props = {
  /**
   * When true, renders the screen in "attract mode": typing animation on the
   * answer line, late-appearing hint/buttons, and a floating "+12 XP" reward.
   * Driven entirely by CSS (see styles/animations.css).
   */
  attract?: boolean;
};

export const SessionScreen = ({ attract = false }: Props) => (
  <div className={`scr scr--session${attract ? ' is-attracting' : ''}`}>
    <div className="scr__hud">
      <span className="hud__chip">Q 1 / 1</span>
      <span className="hud__chip hud__chip--yellow">02:14</span>
    </div>

    <p className="scr__eyebrow">Debugging · Junior</p>
    <h3 className="scr__h scr__h--sm">
      Why does this return <span className="mono">undefined</span>?
    </h3>

    <pre className="scr__code">{`function total(items) {
  items.forEach(i => {
    return i.price;
  });
}`}</pre>

    <div className="scr__hint">
      <span className="scr__hint-label">HINT · 1 / 3</span>
      <p>What does forEach&apos;s return value actually do?</p>
    </div>

    <div className="scr__answer">
      <p className="scr__answer-label">YOUR ANSWER</p>
      <p className="scr__answer-text">forEach ignores returns; total returns nothing…</p>
    </div>

    <div className="scr__btn-row">
      <span className="scr__btn scr__btn--ghost">Need a hint</span>
      <span className="scr__btn">Submit</span>
    </div>

    {attract && (
      <span className="scr__attract-xp" aria-hidden="true">
        +12 XP
      </span>
    )}
  </div>
);
